import { taskApi } from "api/tasks/taskApi";

const getDisplayName = (user) => {
  if (!user) return "";
  if (typeof user === "string") return user;

  const firstName =
    user.first_name ||
    user.firstname ||
    user.user?.first_name ||
    user.user_details?.first_name ||
    "";
  const lastName =
    user.last_name ||
    user.lastname ||
    user.user?.last_name ||
    user.user_details?.last_name ||
    "";
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    user.full_name ||
    user.name ||
    fullName ||
    user.username ||
    user.email ||
    user.user_email ||
    ""
  );
};

const getCurrentUserName = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return getDisplayName(user?.data || user);
  } catch (_) {
    return "";
  }
};

const getCreatedBy = (record) => {
  const source =
    record?.data?.created_by ||
    record?.created_by ||
    record?.data?.last_updated_by ||
    record?.last_updated_by ||
    record?.data?.created_by_details ||
    record?.created_by_details ||
    record?.data?.user ||
    record?.user;

  return getDisplayName(source) || getCurrentUserName() || "A user";
};

export const formatTaskUpdateAmount = (amount) => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) {
    return "Rs. 0";
  }

  return `Rs. ${numericAmount.toLocaleString("en-IN")}`;
};

export const buildGeneralTransactionTaskUpdate = ({
  record,
  amount,
  transactionType,
}) => {
  const purpose = transactionType ? ` for ${transactionType}` : "";
  return `${getCreatedBy(record)} created a general transaction of ${formatTaskUpdateAmount(amount)}${purpose}.`;
};

export const buildWorkerPaymentTaskUpdate = ({
  record,
  amount,
  workerName,
  paymentType,
}) => {
  const worker = workerName ? ` for ${workerName}` : "";
  const type = paymentType ? `${paymentType.toLowerCase()} ` : "";
  return `${getCreatedBy(record)} created a worker ${type}payment of ${formatTaskUpdateAmount(amount)}${worker}.`;
};

export const buildContractorPaymentTaskUpdate = ({
  record,
  amount,
  contractorName,
  paymentLabel,
}) => {
  const contractor = contractorName ? ` for ${contractorName}` : "";
  const label = paymentLabel ? ` (${paymentLabel})` : "";
  return `${getCreatedBy(record)} recorded a contractor payment of ${formatTaskUpdateAmount(amount)}${contractor}${label}.`;
};

export const buildStockTaskUpdate = ({
  record,
  action,
  quantity,
  uom,
  materialName,
  isEdit,
}) => {
  const verb = isEdit ? "updated" : action === "added" ? "added" : "used";
  const numericQuantity = Number(quantity);
  const formattedQuantity = Number.isFinite(numericQuantity)
    ? numericQuantity.toLocaleString("en-IN")
    : "0";
  const material = materialName ? ` of ${materialName}` : "";
  const unit = uom ? ` ${uom}` : "";
  return `${getCreatedBy(record)} ${verb} ${formattedQuantity}${unit}${material}.`;
};

export const createLinkedTaskUpdate = async (taskId, comment) => {
  if (!taskId || !comment) return null;

  try {
    return await taskApi.createTaskUpdate(taskId, comment);
  } catch (error) {
    console.error("Failed to create linked task update:", error);
    return null;
  }
};
